<template>
  <div id="care-package">
    <p class="header">{{ header }}</p>
    <img
      :src="iconUrl"
      class="package"
      :class="{ hover: state === 'ready', deploy: state === 'deploying' }"
    >
    <p class="info">{{ info }}</p>
    <div
      class="timer"
      v-if="state === 'waiting'"
    >
      <p class="countdown">{{minutes}}:{{seconds}}</p>
      <p>Minutes until your next care package is ready.</p>
    </div>
    <div class="actions">
      <button
        class="button warning"
        @click="deploy()"
        v-if="state === 'ready'"
      >DEPLOY PACKAGE</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import moment from "moment";
  import * as open_package_icon from "@/assets/icons/care_packages/open-care-package.svg";
  import * as care_package_icon from "@/assets/icons/care_packages/care-package.svg";

  function formatDuration(duration) {
    if (duration <= 0) return "00";
    return duration < 10 ? "0" + duration : duration;
  }

  export default {
    name: "CarePackage",
    data() {
      return {
        deployed: false,
        carePackageTimeLeft: 0,
        states: {
          waiting: {
            header: "TIME TO STOCK UP",
            info: "We're collecting more supplies for you!",
            iconUrl: open_package_icon
          },
          ready: {
            header: "IT CAN BE A TOUGH JOB ADVENTURING OUT THERE!",
            info: "Send a care package to keep your pathfinder fully supplied.",
            iconUrl: care_package_icon
          },
          deploying: {
            header: "YOUR CARE PACKAGE WAS DEPLOYED",
            info:
              "Watch for your package on the tree. Your pathfinder should recieve it soon.",
            iconUrl: care_package_icon
          }
        }
      };
    },
    computed: {
      ...mapGetters(["nextCarePackageTime"]),
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder
      }),
      available() {
        return this.carePackageTimeLeft <= 0;
      },
      minutes() {
        return formatDuration(
          moment.duration(this.carePackageTimeLeft).minutes()
        );
      },
      seconds() {
        return formatDuration(
          moment.duration(this.carePackageTimeLeft).seconds()
        );
      },
      state() {
        if (this.deployed) {
          return "deploying";
        } else if (this.available) {
          return "ready";
        } else {
          return "waiting";
        }
      },
      iconUrl() {
        return this.states[this.state].iconUrl;
      },
      header() {
        return this.states[this.state].header;
      },
      info() {
        return this.states[this.state].info;
      }
    },
    methods: {
      ...mapActions(["deployCarePackage"]),
      deploy() {
        this.deployed = true;
        this.carePackageTimeLeft = 1;
        this.deployCarePackage(this.pathfinder).then(_ => {
          this.deployed = false;
        });
      }
    },
    mounted() {
      setInterval(() => {
        this.carePackageTimeLeft = moment(this.nextCarePackageTime).diff(
          moment()
        );
      }, 1000);
    }
  };
</script>

<style lang="scss">
  #care-package {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      text-align: center;
    }

    p.header {
      font-weight: bold;
    }

    .package {
      height: 20em;
    }

    .timer {
      .countdown {
        font-size: 2.5em;
        font-weight: bold;
      }
    }

    .actions {
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 1em;

      button {
        width: 85%;
        height: 3em;
      }
    }

    @keyframes cp_hover {
      0% {
        transform: translateY(0px) scaleY(1);
      }
      100% {
        transform: translateY(-30px) scaleY(1.02);
      }
    }

    .hover {
      animation-duration: 3000ms;
      animation-iteration-count: infinite;
      animation-direction: alternate-reverse;
      animation-timing-function: ease-in-out;
      background-repeat: no-repeat;
      animation-name: cp_hover;
    }

    @keyframes deploy {
      0% {
        transform: translate(0px, 0px) scale(1) rotate(0deg);
      }
      15% {
        transform: translate(25px, -5px) scale(0.9) rotate(4deg);
        opacity: 1;
      }
      40% {
        transform: translate(50px, -18px) scale(0.7) rotate(0deg);
        opacity: 1;
      }
      65% {
        transform: translate(75px, -38px) scale(0.5) rotate(-4deg);
        opacity: 1;
      }
      100% {
        transform: translate(100px, -50px) scale(0.3) rotate(0deg);
        opacity: 0;
      }
    }

    .deploy {
      animation: deploy 3s;
      background-repeat: no-repeat;
      animation-timing-function: linear;
      transform-origin: 50% 10%;
      animation-fill-mode: forwards;
    }
  }
</style>
